import React, { useState } from 'react';
import HeaderDetalles from './Detalles/HeaderDetalles';
import BodySeccion from './Detalles/BodyDetalles';
import FooterSeccion from './Detalles/FooterDetalles';
import { AppProvider } from './graficos/GraficoContext';
import { esCelular, topFooterOnExpanded, widthCelular } from './Config';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { DEFAULT_FILTER, ArcFiltros } from './Detalles/SesionDetalles';


interface DetallesProps { 
  onToggleDetalles: (id: any) => void;
  indicador: any;
}

const Detalles: React.FC<DetallesProps> = ({ onToggleDetalles, indicador }) => {
  const [filtrar, setFilters] = useState<number>(0);
  const [codigoDivipola, setCodigoDivipola] = useState('');
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);
  const [isFooterExpanded, setIsFooterExpanded] = useState(false);

  // Si viene el parámetro ?details=true en la URL, sobrescribimos el indicador
  const queryParams = new URLSearchParams(window.location.search);
  const showDetailsFromUrl = queryParams.get('details') === 'true';



 

  if (showDetailsFromUrl) {

   // alert("showDetailsFromUrl");

    
    if(DEFAULT_FILTER.IsFilter==false)
    {
        DEFAULT_FILTER.tipoClasificador= queryParams.get('tipoClasificador') || '';
      DEFAULT_FILTER.tipoValor= queryParams.get('tipoValor') || '';
      DEFAULT_FILTER.idVariable= queryParams.get('idVariable') || '';
      DEFAULT_FILTER.codigo= queryParams.get('idVariable') || '';
      DEFAULT_FILTER.indicador= queryParams.get('indicador') || '';
      DEFAULT_FILTER. sector=queryParams.get('sector') || '';
      DEFAULT_FILTER.entidad= '';
      DEFAULT_FILTER.anio=queryParams.get('anio') || '2026';
      DEFAULT_FILTER.unidadMedida= '';
      DEFAULT_FILTER.esPDET= "0";
      DEFAULT_FILTER.codigoDivipolaDpto= '';
      DEFAULT_FILTER.codigoDivipolaMpio= '';
      DEFAULT_FILTER.codigoDivipolaPdetRegion= '';
      DEFAULT_FILTER.internos= ''

      indicador = {
        tipoClasificador: queryParams.get('tipoClasificador') || '',
        tipoValor: queryParams.get('tipoValor') || '',
        idVariable: queryParams.get('idVariable') || '',
        codigo: queryParams.get('idVariable') || '',
        indicador: queryParams.get('indicador') || '',
        sector: queryParams.get('sector') || '',
        entidad: '',
        anio: parseInt(queryParams.get('anio') || '2026'),
        meta: 0,
        avancePeriodo: 0,
        avanceDesagregacion: 0,
        unidadMedida: '',
        fechaReporte: '',
        esPDET: true,
        esFichaDepartamental: true,
        id: '',
        capaPDETActiva: '',
        codigoDivipolaDpto: '',
        codigoDivipolaMpio: '',
        codigoDivipolaPdetRegion: '',
        internos: ''
      };


    }else{

      DEFAULT_FILTER.internos= ''

      indicador = {
        tipoClasificador: queryParams.get('tipoClasificador') || '',
        tipoValor: queryParams.get('tipoValor') || '',
        idVariable: queryParams.get('idVariable') || '',
        codigo: queryParams.get('idVariable') || '',
        indicador: queryParams.get('indicador') || '',
        sector: queryParams.get('sector') || '',
        entidad: '',
        anio: DEFAULT_FILTER.anio,
        meta: 0,
        avancePeriodo: 0,
        avanceDesagregacion: 0,
        unidadMedida: '',
        fechaReporte: '',
        esPDET: true,
        esFichaDepartamental: true,
        id: '',
        capaPDETActiva: '',
        codigoDivipolaDpto: DEFAULT_FILTER.codigoDivipolaDpto,
        codigoDivipolaMpio: DEFAULT_FILTER.codigoDivipolaMpio,
        codigoDivipolaPdetRegion: '',
        internos: ''
      };

    }

     
     

     
   }
 
   let indicadorJson: any = {};
   try {
     indicadorJson = typeof indicador === 'string' ? JSON.parse(indicador) : indicador;
   } catch (e) {
     indicadorJson = { error: 'Formato inválido de JSON', raw: indicador };
   }

  return (    
    <AppProvider>
      <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
        {esCelular ? (
          <>
            <div>
              <button
                onClick={() => setIsHeaderExpanded(!isHeaderExpanded)}
                style={{
                  width: '100%',
                  padding: '10px',
                  background: '#f0f0f0',
                  border: 'none',
                  borderBottom: '1px solid #ddd',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
              >
                <span>Filtros</span>
                {isHeaderExpanded ? <FaChevronUp /> : <FaChevronDown />}
              </button>
              <div style={{
                maxHeight: isHeaderExpanded ? '500px' : '0',
                overflow: 'hidden',
                transition: 'max-height 0.3s ease-in-out'
              }}>
                <HeaderDetalles 
                  indicador={indicador} 
                  onFilterChange={setFilters} 
                  codigoDivipola={codigoDivipola} 
                  onToggleDetalles={onToggleDetalles} 
                  visibleFilters={["Anio", "Periodo", "TipoClasificador", "DivipolaDpto", "DivipolaMpio", "DivipolaPdetDepartamento", "DivipolaPdetRegion", "DivipolaPdetMunicipio"]} 
                />
              </div>
            </div>
            <BodySeccion 
              setCodigoDivipola={setCodigoDivipola} 
              filtrar={filtrar} 
              codigoDivipola={codigoDivipola} 
              indicador={indicador} 
            />
            <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column-reverse' }}>
              <button
                onClick={() => setIsFooterExpanded(!isFooterExpanded)}
                style={{
                  width: '100%',
                  padding: '10px',
                  background: '#f0f0f0',
                  border: 'none',
                  borderTop: '1px solid #ddd',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
              >
                <span>Detalles</span>
                {isFooterExpanded ? <FaChevronDown /> : <FaChevronUp />}
              </button>
                <div style={{
                backgroundColor: '#f0f0f0',
                maxHeight: isFooterExpanded ? '400px' : '0',
                overflow: 'hidden',
                transition: 'max-height 0.3s ease-in-out',
                height: isFooterExpanded ? '400px' : '0',
                position: isFooterExpanded ? 'absolute' : 'relative',
                top: isFooterExpanded ? topFooterOnExpanded : '0',
                width: widthCelular,
                overflowX: 'auto' // Added horizontal scroll
                }}>
                <FooterSeccion 
                  filtrar={filtrar} 
                  codigoDivipola={codigoDivipola} 
                  indicador={indicador} 
                />
                </div>
            </div>
          </>
        ) : (
          <>



            <HeaderDetalles 
              indicador={indicador} 
              onFilterChange={setFilters} 
              codigoDivipola={codigoDivipola} 
              onToggleDetalles={onToggleDetalles} 
              visibleFilters={["Anio", "Periodo", "TipoClasificador", "DivipolaDpto", "DivipolaMpio", "DivipolaPdetDepartamento", "DivipolaPdetRegion", "DivipolaPdetMunicipio"]} 
            />
            <BodySeccion 
              setCodigoDivipola={setCodigoDivipola} 
              filtrar={filtrar} 
              codigoDivipola={codigoDivipola} 
              indicador={indicador} 
            />
            <FooterSeccion 
              filtrar={filtrar} 
              codigoDivipola={codigoDivipola} 
              indicador={indicador} 
            />
          </>
        )}
      </div>        
    </AppProvider>
  );
};

export default Detalles;